export default __webpack_public_path__ + "static/media/D041_tn.6e271422.jpg";